/* eslint-disable react-hooks/exhaustive-deps */
/** Header del layout: botón de menú en mobile, bloque central con sucursal · módulo y nombre del proceso según la ruta, y avatar con rol que abre el dropdown. */
import { Avatar, Button, Layout } from "antd";
import { MdMenu, MdPerson } from "react-icons/md";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { MenuItem } from "@/types";
import { useUIStore } from "@/stores/uiStore";
import { useWorkSession, useRoles } from "@/hooks";
import DropDownMenu from "./DropDownMenu";
import "./header.css";

interface LayoutHeaderProps {
  menuItems: MenuItem[] | undefined;
  setSideBarMenuKey: (key: string) => void;
  /** Abre el drawer lateral en mobile (en desktop el Sider va siempre colapsado). */
  onOpenMobileSidebar: (open: boolean) => void;
  isMobile: boolean;
}

const LayoutHeader: React.FC<LayoutHeaderProps> = ({
  menuItems,
  setSideBarMenuKey,
  onOpenMobileSidebar,
  isMobile,
}) => {
  const location = useLocation();
  const currentModule = useUIStore((s) => s.currentModule);
  const { loggedUserInnerwork, activeSucursal } = useWorkSession();
  const { nombreRolPrincipal } = useRoles();

  const etiquetaRol = nombreRolPrincipal;

  useEffect(() => {
    const pathname = location.pathname;
    const pathKey = pathname.replace("/", "");
    const foundItem = menuItems?.find((item) => item.pathProceso === pathKey);
    if (foundItem) {
      setPathnameHeader(foundItem.nombreItemMenu);
      setSideBarMenuKey(`/${foundItem.pathProceso}`);
    } else {
      setPathnameHeader("");
    }
  }, [location.pathname, menuItems]);

  const [pathnameHeader, setPathnameHeader] = useState("");

  const modules = useUIStore((s) => s.modules);

  const renderHeaderPathModule = () => {
    const mod = modules.find((m) => m.value === currentModule);
    const contexto = [activeSucursal?.nombre, mod?.label].filter(Boolean).join(" · ");
    return (
      <div style={{ textAlign: "center" }}>
        {contexto && <div className="header-contexto">{contexto}</div>}
        {pathnameHeader && <div className="header-proceso">{pathnameHeader}</div>}
      </div>
    );
  };

  const nombreUsuario = loggedUserInnerwork?.nombre || loggedUserInnerwork?.codUsuario || "";

  return (
    <Layout.Header className="header-wrapper" style={{ padding: "0 25px" }}>
      <div className="header-spacer">
        {isMobile && (
          <Button
            type="text"
            icon={<MdMenu size={18} />}
            onClick={() => onOpenMobileSidebar(true)}
            style={{ fontSize: "16px" }}
          />
        )}
      </div>
      <div className="header-center">{renderHeaderPathModule()}</div>
      <div className="header-actions">
        <DropDownMenu>
          <div className="header-user">
            <Avatar
              shape="square"
              size={26}
              icon={<MdPerson size={14} />}
              style={{ cursor: "pointer" }}
            />
            {nombreUsuario && <span className="header-user-name">{nombreUsuario}</span>}
            {etiquetaRol && <span className="header-user-rol">{etiquetaRol}</span>}
          </div>
        </DropDownMenu>
      </div>
    </Layout.Header>
  );
};

export default LayoutHeader;
